import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware'

import useLoadingStore from './useLoadingStore';
import { apiDomain, basename } from '../setting';

const useAuthAdminStore = create(
    persist(
        (set, get) => ({
            token: "",
            firstName: "",
            lastName: "",
            role: "",
            roleDesc: "",
            isAuthenticated: () => {
                return get().token !== "";
            },
            isCSTeam: () => {
                const { role } = get();
                return role === "CSVIEW" || role === "CSADM";
            },
            isAdminUser: () => {
                const { role } = get();
                return role === "CSADM" || role === "CLMADM" || role === "SUPERADM";
            },
            adminAuthenticate: async (email, pwd) => {
                const { setLoading } = useLoadingStore.getState();

                setLoading(true);

                const response = await fetch(`${apiDomain}/${basename}/api/general/adminauthenticate`, {
                    method: 'POST',
                    body: JSON.stringify({
                        "email": email.trim(),
                        "pwd": encodeURIComponent(pwd.trim()),
                    })
                });

                const data = await response.json();

                if (response.status === 401) { // Unauthorized
                    setLoading(false);
                    throw new Error('Unauthorized Signin');
                }

                if (!response.ok) {
                    setLoading(false);
                    throw new Error('Network Error');
                }

                set({
                    token: data.token,
                    firstName: data.staffFirstName,
                    lastName: data.staffLastName,
                    role: data.role,
                    roleDesc: data.roleDesc,
                });

                setLoading(false);

                return true;
            },
            logout: () => {
                set({
                    token: "",
                    firstName: "",
                    lastName: "",
                    role: "",
                });
            },
        }),
        {
            name: 'authAdmin',
        },
    ),
)

export default useAuthAdminStore;